/**
 * The readability floor (POLISH v1 rule 2) as one style rule a page puts on its root: every control at
 * least 44px tall, every badge/tag/code chip at 14px. Checkboxes and radios keep their own size. It is a
 * safety net under the per-component sizes, not a substitute for them.
 */
export const FLOOR_SX = {
  "& button, & a.chakra-button, & select, & input:not([type=checkbox]):not([type=radio])": { minHeight: "44px" },
  "& .chakra-badge, & .chakra-tag, & .chakra-tag__label, & .chakra-code, & .chakra-form__helper-text, & .chakra-form__error-message": { fontSize: "var(--chakra-fontSizes-sm)" },
};
